import React from 'react';
import styled from 'styled-components';

import InstagramIcon from '@icons/crm/messengers/Instagram';
import WhatsAppIcon from '@icons/crm/messengers/Whatsapp';
import TelegramIcon from '@icons/crm/messengers/Telegram';
import FacebookMessengerIcon from '@icons/crm/messengers/FacebookMessenger';
import FacebookIcon from '@icons/crm/messengers/Facebook';
import ViberIcon from '@icons/crm/messengers/Viber';
import MailIcon from '@icons/crm/messengers/Mail';
import VKIcon from '@icons/crm/messengers/Vk';
import MaxIcon from '@icons/crm/messengers/Max';
import DefaultIcon from '@icons/crm/messengers/Default';
import { ValueOf } from '@utils/tsUtils';

export const Types = {
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  TELEGRAM: 'telegram',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  FACEBOOK: 'facebook',
  VIBER: 'viber',
  MAIL: 'mail',
  VK: 'vk',
  MAX: 'max',
};

interface IMessenger {
  className?: string;
  type: ValueOf<typeof Types>;
}

const Messenger = ({ className = '', type }: IMessenger) => {
  const getIconByType = (type: IMessenger['type']) => {
    switch (type) {
      case Types.INSTAGRAM:
        return <InstagramIcon />;
      case Types.WHATSAPP:
        return <WhatsAppIcon />;
      case Types.TELEGRAM:
        return <TelegramIcon />;
      case Types.FACEBOOK_MESSENGER:
        return <FacebookMessengerIcon />;
      case Types.FACEBOOK:
        return <FacebookIcon />;
      case Types.VIBER:
        return <ViberIcon />;
      case Types.MAIL:
        return <MailIcon />;
      case Types.VK:
        return <VKIcon />;
      case Types.MAX:
        return <MaxIcon />;
      default:
        return <DefaultIcon />;
    }
  };
  return (
    <StyledMessenger className={className} title={type}>
      {getIconByType(type)}
    </StyledMessenger>
  );
};

const StyledMessenger = styled.div`
  width: 100%;
  overflow: hidden;
  min-width: 16px;
  height: auto;
  max-width: 30px;

  > svg {
    height: 100%;
    width: 100%;
  }
`;

export default Messenger;
